/**
 * This exception is thrown when a user isn't confirmed successfully.
 */
export class UserNotConfirmedException extends Error {}

/**
 * This exception is thrown when a user isn't authorized.
 */
export class NotAuthorizedException extends Error {}

/**
 * This exception is thrown when the user has made too many failed attempts for a given action, such as sign-in.
 */
export class TooManyFailedAttemptsException extends Error {}

/**
 * This exception is thrown if the provided code doesn't match what the server was expecting.
 */
export class CodeMismatchException extends Error {}

/**
 * This exception is thrown if a code has expired.
 */
export class ExpiredCodeException extends Error {}

/**
 * Indicates that the action failed, and the message could not be sent.
 * Check the error stack for more information about what caused the error.
 */
export class MessageRejectedException extends Error {}

/**
 * This exception is thrown when a user exceeds the limit for a requested AWS resource.
 */
export class LimitExceededException extends Error {}
